import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';

import { Store } from '@ngrx/store';
import { OAuthService } from 'angular-oauth2-oidc';
import { Observable } from 'rxjs/Observable';

import { Agency } from './agencies.model';
import { State } from '../../state-management/reducers/index';
import * as AppStateActions from '../../state-management/actions/app-state';

@Injectable()
export class AgenciesService implements CanActivate {
	private _cache: Array<Agency>;

	constructor(
		private _http: HttpClient,
		private _oauthService: OAuthService,
		private _store: Store<State>
	) {}

	public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
		return this.getAgencies().map(agencies => {
			this._store.dispatch(new AppStateActions.SetAgencies(agencies));
			return true;
		}).catch(() => Observable.of(false));
	}

	public getAgencies(): Observable<Array<Agency>> {
		const token = this._oauthService.getAccessToken();

		if (this._cache) {
			return Observable.of(this._cache);
		}

		return this._http.get<Array<Agency>>(
			'https://agencies.go-suite.com',
			{headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)}
		).do(response => this._cache = response);
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/services/agencies/agencies.service.ts